module.exports = __webpack_public_path__ + "static/assets/7d4fa08c40e2fac41e67fb4f143535d0.gif";